import Cookies from 'js-cookie';

import { CodementumUrl } from './codementum-url';

type CookieAttributes = Cookies.CookieAttributes;

function mergeOptions(options: CookieAttributes = {}) {
  let domain = CodementumUrl.cookieDomain();
  if (window.location.hostname.includes('localhost')) {
    domain = 'localhost';
  }

  return {
    domain,
    ...options
  };
}

export const AUTH_COOKIE_NAME = 'CODEMENTUM_AUTH';
export const AUTH_OLD_COOKIE_NAME = `${AUTH_COOKIE_NAME}_OLD`;
export const AUTH_OLD_ACCOUNT_COOKIE_NAME = `${AUTH_COOKIE_NAME}_OLD_ACCOUNT`;
export const CM_REDIRECT_PATH = 'CODEMENTUM_REDIRECTBACK_PATH';

export class CookieManager {
  static get AUTH_COOKIE_NAME() {
    return AUTH_COOKIE_NAME;
  }
  static get AUTH_OLD_COOKIE_NAME() {
    return AUTH_OLD_COOKIE_NAME;
  }
  static get AUTH_OLD_ACCOUNT_COOKIE_NAME() {
    return AUTH_OLD_ACCOUNT_COOKIE_NAME;
  }
  static get CM_REDIRECT_PATH() {
    return CM_REDIRECT_PATH;
  }

  static get(key: string) {
    return Cookies.get(key);
  }

  static set(key: string, value: string, options?: CookieAttributes) {
    options = mergeOptions(options);
    Cookies.set(key, value, options);

    return CookieManager.get(key);
  }

  static remove(key: string, options?: CookieAttributes) {
    options = mergeOptions(options);
    Cookies.remove(key, options);

    return !!CookieManager.get(key);
  }

  static getTokenString() {
    try {
      const { accessToken, tokenType } = JSON.parse(
        CookieManager.get(CookieManager.AUTH_COOKIE_NAME)!
      );

      return `${tokenType} ${accessToken}`;
    } catch {
      return 'null null';
    }
  }

  static simulateUser(account: string) {
    if (CookieManager.get(AUTH_COOKIE_NAME)) {
      CookieManager.set(AUTH_OLD_ACCOUNT_COOKIE_NAME, account);
      CookieManager.set(
        AUTH_OLD_COOKIE_NAME,
        CookieManager.get(AUTH_COOKIE_NAME)!,
        {
          sameSite: 'strict'
        }
      );
      CookieManager.set(CM_REDIRECT_PATH, window.location.pathname);
    }
  }

  static isSimulated() {
    return CookieManager.get(AUTH_OLD_COOKIE_NAME);
  }

  static loginBack() {
    CookieManager.set(
      AUTH_COOKIE_NAME,
      CookieManager.get(AUTH_OLD_COOKIE_NAME)!,
      {
        sameSite: 'strict'
      }
    );
    CookieManager.removeOld();

    const redirectPath =
      CookieManager.get(CM_REDIRECT_PATH) || '/account/profile/info';
    CookieManager.remove(CM_REDIRECT_PATH);

    return window.location.origin + redirectPath;
  }

  static logout(redirectURI: string | null = null) {
    CookieManager.remove(AUTH_COOKIE_NAME);
    CookieManager.removeOld();

    if (redirectURI) {
      window.location.href = redirectURI;
      return;
    }

    window.location.href = '/login';
  }

  static removeOld() {
    CookieManager.remove(AUTH_OLD_COOKIE_NAME);
    CookieManager.remove(AUTH_OLD_ACCOUNT_COOKIE_NAME);
  }
}
